<template>
  <van-row type="flex" :justify="justify">
    <van-col v-for="(item, key) in list" :key="key" :class="item.name">
      <base-link :data="item" />
    </van-col>
  </van-row>
</template>

<script>
import BaseLink from "@/components/BaseLink";

export default {
  name: "BaseLinkList",
  components: { BaseLink },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    justify: {
      type: String,
      default: "space-between"
    }
  }
};
</script>
